<script>
import {mapActions, mapState} from 'vuex';

export default {
  data() {
    return {
      timeout: 0,
    }
  },
  computed: {
    ...mapState('timer', ['tick']),
  },
  mounted() {
    this.timeout = setInterval(() => {
      this.setTick(this.timeout);
        return this.timeout++;
      }, 1000);
  },
  methods: {
    ...mapActions('timer', ['setTick']),
  }
}
</script>

<template>
  <div>

  </div>
</template>


